import { STATUS_CODE } from '../data/system_settings'
import { baseServiceExportExcel } from './baseServiceExportExcel'
class ExportExcelService extends baseServiceExportExcel {
  baseURL = `admin/export`

  async export() {
    try {
      const res = await this.get(this.baseURL)
      if (res.status === STATUS_CODE.SUCCESS) {
        // Lấy dữ liệu nhị phân (blob)
        const blob = await res.blob()
        return { status: res.status, data: blob }
      } else {
        throw new Error('Xuất Excel thất bại')
      }
    } catch (error) {
      throw error
    }
  }
}

export const exportExcelService = new ExportExcelService()
